
import { useState } from 'react';

export default function CampSchedule() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [password, setPassword] = useState('');
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [scheduleImages, setScheduleImages] = useState<string[]>([
    'https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/f4fb03d248ce8f4ac630ae67253b9c2c.jpeg',
    'https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/8a1d1e1466c41355d6498d358387f010.jpeg'
  ]);

  const handlePasswordSubmit = () => {
    if (password === 'admin123') {
      setIsAdmin(true);
      setShowPasswordModal(false);
      setPassword('');
    } else {
      alert('密碼錯誤！');
    }
  };

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const newImages: string[] = [];
      
      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          newImages.push(e.target?.result as string);
          if (newImages.length === files.length) {
            setScheduleImages(prev => [...prev, ...newImages]);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  const removeImage = (index: number) => {
    setScheduleImages(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-pink-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-pink-500" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上國語文寫作教室
              </h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">首頁</a>
                <a href="/courses" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">課程介紹</a>
                <a href="/teachers" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">師資團隊</a>
                <a href="/results" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">教學成果</a>
                <a href="/trial" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">免費試聽</a>
                {!isAdmin && (
                  <button 
                    onClick={() => setShowPasswordModal(true)}
                    className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
                  >
                    管理員登入
                  </button>
                )}
                {isAdmin && (
                  <button 
                    onClick={() => setIsAdmin(false)}
                    className="text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer bg-pink-50 rounded-full"
                  >
                    登出管理
                  </button>
                )}
              </div>
            </div>
            <div className="md:hidden">
              <button className="text-gray-700 hover:text-pink-500 w-6 h-6 flex items-center justify-center cursor-pointer">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-pink-50 via-rose-50 to-pink-100 py-16">
        <div className="absolute inset-0 bg-white/30"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-pink-500/10 text-pink-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-calendar-check-fill text-pink-500"></i>
            <span>寒假冬令營課表</span>
          </div>
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            寒假寫作冬令營
            <span className="text-pink-500 block lg:inline lg:ml-4">課程時間表</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8 leading-relaxed">
            詳細的課程安排與時間規劃<br/>
            讓您清楚了解每日課程內容與進度
          </p>
        </div>
      </section>

      {/* Schedule Images */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {isAdmin && (
            <div className="mb-8 text-center">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 hover:border-pink-500 transition-colors">
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleImageUpload}
                  className="hidden"
                  id="image-upload"
                />
                <label htmlFor="image-upload" className="cursor-pointer">
                  <div className="flex flex-col items-center">
                    <i className="ri-upload-cloud-2-line text-4xl text-gray-400 mb-2"></i>
                    <p className="text-gray-600 mb-1">點擊上傳課表圖片</p>
                    <p className="text-sm text-gray-400">支援多張圖片同時上傳</p>
                  </div>
                </label>
              </div>
            </div>
          )}

          <div className="space-y-8">
            {scheduleImages.map((image, index) => (
              <div key={index} className="relative bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
                {isAdmin && (
                  <button
                    onClick={() => removeImage(index)}
                    className="absolute top-4 right-4 z-10 bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer shadow-lg"
                  >
                    <i className="ri-close-line"></i>
                  </button>
                )}
                <img 
                  src={image}
                  alt={`課表 ${index + 1}`}
                  className="w-full h-auto object-contain"
                />
                <div className="absolute bottom-4 left-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm">
                  課表 {index + 1}
                </div>
              </div>
            ))}
          </div>

          {/* Contact Section */}
          <div className="mt-16 text-center">
            <div className="bg-gradient-to-r from-pink-500 to-rose-500 rounded-3xl p-12 text-white">
              <h3 className="text-3xl font-bold mb-6">準備好參加冬令營了嗎？</h3>
              <p className="text-xl text-pink-100 mb-8 max-w-2xl mx-auto">
                早鳥優惠進行中，名額有限！<br/>
                立即報名，讓孩子在寒假中也能持續成長
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="bg-white text-pink-500 px-8 py-4 rounded-full font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer shadow-lg">
                  立即報名冬令營
                </a>
                <a href="/trial" className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-pink-500 transition-colors whitespace-nowrap cursor-pointer">
                  免費試聽課程
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Password Modal */}
      {showPasswordModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">管理員登入</h3>
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                請輸入管理員密碼
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                placeholder="輸入密碼"
                onKeyPress={(e) => e.key === 'Enter' && handlePasswordSubmit()}
              />
            </div>
            <div className="flex gap-4">
              <button
                onClick={() => setShowPasswordModal(false)}
                className="flex-1 border border-gray-300 text-gray-700 py-3 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                取消
              </button>
              <button
                onClick={handlePasswordSubmit}
                className="flex-1 bg-pink-500 text-white py-3 rounded-lg hover:bg-pink-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                登入
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold mb-4 text-pink-400" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上國語文寫作教室
              </h3>
              <p className="text-gray-400 mb-6 leading-relaxed">
                專業線上寫作教室，致力於培養孩子的寫作能力與創意思維。
                我們相信每個孩子都有無限潛能，只需要正確的引導。
              </p>
              <div className="flex gap-4">
                <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-line-fill text-lg"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">快速連結</h4>
              <ul className="space-y-2">
                <li><a href="/courses" className="text-gray-400 hover:text-white transition-colors cursor-pointer">課程介紹</a></li>
                <li><a href="/teachers" className="text-gray-400 hover:text-white transition-colors cursor-pointer">師資團隊</a></li>
                <li><a href="/results" className="text-gray-400 hover:text-white transition-colors cursor-pointer">教學成果</a></li>
                <li><a href="/trial" className="text-gray-400 hover:text-white transition-colors cursor-pointer">免費試聽</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center gap-2">
                  <i className="ri-line-fill"></i>
                  <a href="https://lin.ee/3Slg6R2Zx" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">@write123</a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-fill"></i>
                  <span>週一至週日 9:00-21:00</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-global-fill"></i>
                  <span>線上教學，不限地區</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 共學趣線上寫作教室. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
